import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';



import Button from '@mui/material/Button';

import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';


const styles = theme => ({

    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }

});

class AcknowledgeRegularisationStock extends React.Component {


    render() {
        const { classes, onClickSave, isAdding } = this.props;


        return (

            <Button
                onClick={onClickSave}
                variant="contained"
                color="secondary"
                disabled={isAdding}
            >
                {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                Régularisation faite
            </Button>
        );
    }
}
AcknowledgeRegularisationStock.propTypes = {
    onClickSave: PropTypes.func.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(AcknowledgeRegularisationStock);